import { CastingState } from './types';

export const castingInitialState: CastingState = {
  castingSessionId: null,
};
